<template>
	<div class="accountSetting pl-xl-4">
        <div class="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
            <h5 class="medium mb-0 d-flex align-items-center"><img class="mr-2" src="../../../../../static/website/images/lapIcon.png" alt="Device" title="Bank List"> <span class="secondary">Bank List</span></h5>
            <a @click.prevent="addBankModal = !addBankModal" href="javascript:void(0)" class="cap_btn-b small py-2">Add New Bank</a> 
        </div>


        <div  class="modal fade review" :class="addBankModal? 'show' : ''" v-if="addBankModal" id="addnewBankModal">
            <div class="modal-dialog modal-dialog-centered max-800" role="document">
                <div class="modal-content">
                    <div class="p-4 border-bottom modal-header bg-none">
                        <h5 class="mb-0">Add New Bank</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="addBankModal = false">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body px-4">
                        <add-bank :pageNameData="'settings'"></add-bank>
                    </div>
                </div>
            </div>
        </div>

        <!-- <section class="add_ipaddress px-0 pb-md-5" :class="addBankModal?'d-block':'d-none'">
            <div class="section_title">
                <h5>Add New Bank</h5>
            </div>
            <div class="custom-IP-section">
                <add-bank :pageNameData="'settings'"></add-bank>
            </div>
        </section> -->

        <div class="marketData table-responsive smallFont">
            <bank-list></bank-list>
        </div>
    </div>
</template>

<script>
    import addBank from "../../bank/add-bank";
    import bankList from "../../bank/bank-list";
    export default {
        name: 'Bank',
        mixins: [],
        data(){
            return {
                addBankModal : false
            }
        },
        components: {
            addBank,bankList
        },
        methods: {},
        created(){}
    }
</script>



// WEBPACK FOOTER //
// src/components/website/settings/files/bank.vue